/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profilebillingtitle2Inputs */

const en_profilebillingtitle2 = /** @type {(inputs: Profilebillingtitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plan for ${i?.name}`)
};

const de_profilebillingtitle2 = /** @type {(inputs: Profilebillingtitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plan für ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Plan for {name}" |
*
* @param {Profilebillingtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingtitle2 = /** @type {((inputs: Profilebillingtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingtitle2(inputs)
	return de_profilebillingtitle2(inputs)
});
export { profilebillingtitle2 as "profileBillingTitle" }